import React from 'react';
import {Root, Trigger, Content, Arrow, Portal} from '@radix-ui/react-tooltip';
import styles from './tooltip.module.scss';

interface TooltipComponentProps {
  children: React.ReactElement;
  title: string;
}

const TooltipComponent = ({children, title}: TooltipComponentProps) => {
  return (
    <Root>
      <Trigger asChild>
        {children}
      </Trigger>
      <Portal>
        <Content side='top' className={styles.container} sideOffset={5}>
          <span className={styles.title}>
            {title}
          </span>
          <Arrow className={styles.arrow} />
        </Content>
      </Portal>
    </Root>
  );
};

export default TooltipComponent;
